export function secondsTomilliseconds(value: number) {
  return value * 1000;
}

export function millisecondsToseconds(value: number) {
  return value / 1000;
}